export const environment = {
  production: true,
  version: '1.0.0',
  apiUrl: 'https://portalcardealer.michelin.com.br',
  keyToken: 'currentUser',
  keyPermissions: 'permissions'
};
